import actions from '../actions';

const initialState = {
    showOverlay: false,
    overlayType: "",
    showConversationsSearch: false,
    collapseNotes: false
}

export default function uiState(state = initialState, action) {
    switch(action.type) {
        case actions.SHOW_OVERLAY: {
            return Object.assign({}, state, {
                showOverlay: true,
                overlayType: action.overlayType,
                overlayData: action.overlayData
            });
        }
        case actions.HIDE_OVERLAY: {
            return Object.assign({}, state, {
                showOverlay: false
            });
        }
        case actions.SEARCH_KB_SUCCESS: {
            return Object.assign({}, state, {
                collapseNotes: true
            });
        }
        case actions.EXPAND_COLLAPSE_NOTES: {
            return Object.assign({}, state, {
                collapseNotes: action.collapseNotes
            });
        }
        case actions.INSERT_CHAT_INPUT: {
            return Object.assign({}, state, {
                chatInputText: action.text
            });
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/uiStateReducer.js